module.exports = [{"value":"ได้รับการยกเว้น/ไม่ผ่านมาตรฐาน","text":"ได้รับการยกเว้น/ไม่ผ่านมาตรฐาน"},{"value":"ผ่อนผันการเกณฑ์ทหาร","text":"ผ่อนผันการเกณฑ์ทหาร"},{"value":"รอกำหนดการเกณฑ์ทหาร","text":"รอกำหนดการเกณฑ์ทหาร"},{"value":"สำเร็จวิชารักษาดินแดน","text":"สำเร็จวิชารักษาดินแดน"},{"value":"ไม่ต้องเกณฑ์ทหาร","text":"ไม่ต้องเกณฑ์ทหาร"},{"value":"ผ่านการเกณฑ์ทหาร","text":"ผ่านการเกณฑ์ทหาร"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/MilitaryStatus/militaryStatusTH.json
// module id = 1Nit
// module chunks = 2